// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__2TdoN","icon":"SortAdornment_icon__2eOfA","up":"SortAdornment_up__2qX4C","down":"SortAdornment_down__1Sw6U","active":"SortAdornment_active__3kcat"};